import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import './styles.css';


var styles = {
    "heading": "Heading-module_heading__ZDRxc",
    "heading_level1": "Heading-module_heading_level1__1StXc",
    "heading_level2": "Heading-module_heading_level2__OtRYD",
    "heading_level3": "Heading-module_heading_level3__eYgLa",
    "heading_level4": "Heading-module_heading_level4__-NQFC",
    "heading_level5": "Heading-module_heading_level5__WziH0",
    "heading_hasSpacingExtraSmall": "Heading-module_heading_hasSpacingExtraSmall__UGmbl",
    "heading_hasSpacingSmall": "Heading-module_heading_hasSpacingSmall__Umi0k",
    "heading_hasSpacingMedium": "Heading-module_heading_hasSpacingMedium__nkINp",
    "heading_hasSpacingSmallMobileMediumOtherwise": "Heading-module_heading_hasSpacingSmallMobileMediumOtherwise__h9qdd"
};

const Heading = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, as: Tag, level, canBeManuallyFocused, hasSpacing, children }, ref)=>{
    const levelClassName = level ? styles[`heading_level${level}`] : '';
    let spacingClassName = '';
    if (hasSpacing) {
        if (level === 1) {
            spacingClassName = styles.heading_hasSpacingMedium;
        } else if (level === 2) {
            spacingClassName = styles.heading_hasSpacingSmallMobileMediumOtherwise;
        } else if (level === 3 || level === 4) {
            spacingClassName = styles.heading_hasSpacingSmall;
        } else if (level === 5) {
            spacingClassName = styles.heading_hasSpacingExtraSmall;
        }
    }
    return /*#__PURE__*/ jsx(Tag, {
        ref: ref,
        id: id,
        className: `${styles.heading} ${levelClassName} ${spacingClassName} ${className}`.trim(),
        lang: lang,
        "data-testid": dataTestId,
        tabIndex: canBeManuallyFocused ? -1 : undefined,
        children: children
    });
});
Heading.displayName = 'Heading';

export { Heading };
